import type { SVGProps } from "react";

export const Border = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="64"
		height="82"
		fill="none"
		viewBox="0 0 64 82"
		{...props}
	>
		<rect width="62.286" height="80" x="1" y="1" stroke="#0E0E0E" strokeDasharray="7 7" rx="4" />
	</svg>
);
